<template>
  <div class="px-4 pb-4">
    <data-table :columns="columns" :rows="rows">
      <template v-slot:actions="slotProps">
        <b-button v-if="checkForPermission(edit_customer_tier_permission)" v-b-modal.edit-customer-tier variant="success" size="sm" class="py-1 text-white" @click="selectCustomerTier(slotProps.row)">
          Edit
        </b-button>
      </template>
    </data-table>
    <b-modal
        id="edit-customer-tier"
        centered
        size="lg"
        hide-footer
        hide-header
        title-class="font-18">
      <div class="p-2">
        <h3>Edit Customer Tier</h3>
        <customer-tier-form button_text="Edit Customer Tier" :selected_tier="selected_tier" @tierAction="editCustomerTier"/>
        <b-button class="mt-3 float-end" variant="dark" block @click="$bvModal.hide('edit-customer-tier')">Close</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import DataTable from "@/components/data-table";
import {mapActions} from "vuex";
import CustomerTierForm from "@/components/settings/customer-tier-form";
import {successToast} from "@/components/successToast";
import {permissions} from "@/router/permissions";

export default {
name: "customer-tier-table",
  components: {CustomerTierForm, DataTable},
  data(){
    return{
      searchTerm: '',
      selected_tier: {},
      edit_customer_tier_permission: permissions.edit_customer_tier_permission,
      columns: [
        {
          field: 'name',
          label: 'Name'
        },
        {
          field: 'minimumInvoiceTotal',
          label: 'Min Order Total'
        },
        {
          field: 'description',
          label: 'Description'
        },
        {
          field: 'actions',
          label: 'Action'
        }
      ],
    }
  },
  props: {
    rows: {type: Array}
  },
  methods: {
    ... mapActions({
      updateTier: 'user/updateCustomerTier'
    }),
    async editCustomerTier(data){
      data.id = this.selected_tier.publicId
      data.minimumInvoiceTotal = parseFloat(data.minimumInvoiceTotal)
      await this.updateTier(data).then(resp => {
        this.$emit('refetch')
        successToast(`${resp.name} updated successfully`)
      })
    },
    selectCustomerTier(row){
      this.selected_tier = row
    }
  }
}
</script>

<style scoped>

</style>
